var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.43897 25.3777C1.58564 23.351 2.86564 21.2843 4.27897 19.1777C5.71897 17.0443 7.1323 15.0977 8.51897 13.3377C6.14564 10.111 3.63897 6.09767 0.99897 1.29767L2.35897 0.897675C4.4923 5.03101 6.87897 8.93767 9.51897 12.6177H11.199C13.839 8.93767 16.2256 5.03101 18.359 0.897675L19.719 1.29767C17.079 6.09767 14.5723 10.111 12.199 13.3377C13.5856 15.0977 14.9856 17.0443 16.399 19.1777C17.839 21.2843 19.1323 23.351 20.279 25.3777L18.959 25.8177C17.919 23.8977 16.7856 22.031 15.559 20.2177C14.3323 18.3777 12.8523 16.311 11.119 14.0177H9.59897C7.86564 16.311 6.38564 18.3777 5.15897 20.2177C3.9323 22.031 2.79897 23.8977 1.75897 25.8177L0.43897 25.3777Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.2da11c99f26671d4cc5c3c9c81b4c24e.svg";
export { ForwardRef as ReactComponent };